// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1UzM5","buttons":"RemoveExpirationActionButtons_buttons__tY5WA"};